import moment from "moment";
import React from "react";
import InfoGreen from "../../../assets/icons/infoGreen.svg";
import Tooltip from "./Tooltip";

export const ToolTipHover = ({
  capsule_changes_tracker,
  changedBy,
  changedOn,
  typeOfField,
}) => {
  const replace_character = (value) => {
    if (value.includes("_")) {
      return value.replace(/_/g, ".");
    }
    return value;
  };

  const getFieldDetails = () => {
    let quantity = "";
    let oldValues = "";
    let newValues = "";

    if (typeOfField === "capsule_strength") {
      quantity = " mg";
      oldValues =
        replace_character(
          capsule_changes_tracker?.capsule_strength_view_initial
        ) || "Incomplete";
      newValues = replace_character(
        capsule_changes_tracker?.capsule_strength_view_new
      );
    } else if (typeOfField === "capsule_cycle") {
      quantity = " capsules";
      oldValues =
        capsule_changes_tracker?.capsule_cycle_view_initial || "Incomplete";
      newValues = capsule_changes_tracker?.capsule_cycle_view_new;
    } else if (typeOfField === "nr_cycles") {
      quantity = " cycles";
      oldValues =
        capsule_changes_tracker?.nr_cyles_view_initial || "Incomplete ";
      newValues = capsule_changes_tracker?.nr_cyles_view_new;
    } else {
      quantity = "";
      oldValues =
        capsule_changes_tracker.pregnanacy_test_view_initial === "Incomplete"
          ? "Incomplete"
          : moment(capsule_changes_tracker.pregnanacy_test_view_initial).format(
              "DD / MM / YYYY"
            );
      newValues =
        capsule_changes_tracker?.pregnanacy_test_view_new === "Incomplete"
          ? "Incomplete"
          : moment(capsule_changes_tracker?.pregnanacy_test_view_new).format(
              "DD / MM / YYYY"
            );
    }

    return { quantity, oldValues, newValues };
  };

  return (
    <Tooltip>
      <div className="wrraper">
        <div className="wrapper-div-patients">
          <div className="tooltip-status">
            <div>
              <img src={InfoGreen} alt="info" className="info-icon" />
            </div>
            <div className="tooltiptext-status">
              <div className="mb-2">
                <b>Changed by</b> {changedBy}
              </div>
              <div>
                <b>Changed on</b> {moment(changedOn).format("DD / MM / YYYY")} :
              </div>
              <div>
                <b>From</b>: {getFieldDetails().oldValues}
                {getFieldDetails().quantity} to {getFieldDetails().newValues}{" "}
                {getFieldDetails().quantity}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Tooltip>
  );
};
